module.exports = __webpack_public_path__ + "static/media/home.da666579.jpg";